import axios from "axios";

export default {
  getChats(context) {
    axios
      .get(`${process.env.VUE_APP_BASE_ATTACHMENTS_URL}internal-chats`)
      .then((res) =>
        context.commit(
          "setChats",
          res.data.data.map((el) => ({
            ago_time: el.ago_time,
            created_at: el.created_at,
            id: el.id,
            is_read: el.is_read,
            last_message: el.last_messages,
            owner: el.sender,
            online: false,
            last_message_created_at: el.messages?.created_at,
            last_message_created: new Date(el.messages?.created_at).getTime(),
          }))
        )
      );
  },
};
